module.exports = __webpack_public_path__ + "img/bze.ae8e628a.svg";